
import _ from 'lodash';
var  Fingerprint2 = require('fingerprintjs2')
const uuid = {};


uuid.get = function(){

    return new Promise(function(resolve,reject){            


        if(device.platform.toLowerCase() ==  "browser" ) {
 


            if (window.requestIdleCallback) {
                requestIdleCallback(function () {
                    Fingerprint2.get(function (components) {
                        var values = components.map(function (component) { return component.value })
                        var murmur = Fingerprint2.x64hash128(values.join(''), 31)
        
                        resolve(murmur)
                    })
                })
            } else {
                setTimeout(function () {
                    Fingerprint2.get(function (components) {
                        var values = components.map(function (component) { return component.value })
                        var murmur = Fingerprint2.x64hash128(values.join(''), 31)
        
                        resolve(murmur)
                    })  
                }, 500)
            }
            



        } else {


            window.plugins.uniqueDeviceID.get(resolve, reject);




        }

    })


}


export default uuid